import { ProductActionTypes, All } from '../actions/product.actions';
import { Product, ProductSearchCriteria } from '@app/shared/models/product';

// define State interface
export interface State {
  // is a user authenticated?
  selectedProduct: Product | null;
  // if authenticated, there should be a user object
  products: Product[] | null;
  searchCriteria: ProductSearchCriteria | null;
  errorMessage: string | null;
  isEditing: boolean | null;
  actionType: string | null;
}

// define initial state
export const initialState: State = {

  selectedProduct: null,
  products: null,
  searchCriteria:null,
  errorMessage: null,
  isEditing:false,
  actionType:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case ProductActionTypes.GET_PRODUCTS_SUCCESS: {
      return {
        ...state,
        selectedProduct: null,
        products: action.payload.products,
        searchCriteria:action.payload.searchCriteria,
        errorMessage:null,
        actionType:action.type,
      };
    }
    case ProductActionTypes.GET_ALL_PRODUCTS_MEDIA_SUCCESS:
    case ProductActionTypes.GET_PRODUCT_MEDIA_SUCCESS: {
      return {
        ...state,
        actionType:action.type,
      };
    }

    case ProductActionTypes.SET_PRODUCT: {
      return {
        ...state,
        selectedProduct: action.payload.product,
        actionType:action.type,
      };
    }
    case ProductActionTypes.CREATE_PRODUCT:
    case ProductActionTypes.EDIT_PRODUCT: {
      return {
        ...state,
        selectedProduct: action.payload.product,
        isEditing: action.payload.isEditing,
        actionType:action.type,
      };
    }
    case ProductActionTypes.SET_PRODUCT_FAILURE:
    case ProductActionTypes.GET_PRODUCTS_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.statusText,
        actionType:action.type,
      };
    }
    default: {
      return {
        ...state,
        actionType:null,
      };
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/product.reducer.ts